<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのページのメタディスクリプションタグの内容は120文字以内で収まっています。
        </p>
        <p v-else>
          あなたのページのメタディスクリプションタグの内容は{{
            ceiledDescriptionLength
          }}文字です。<br />ほとんどの検索エンジンはメタディスクリプションタグの内容は120文字で切り捨てられます。文字数のカウント方法については
          <a :href="blogLink" target="_blank" @click.stop>こちら</a>
          を参考にしてください。<br />
          ■従来のカウント方法（2021年6月2日以前の調査結果）<br />
          &emsp; 半角文字1文字 / 全角文字2文字<br />
          ■変更後のカウント方法（2021年6月3日以降の調査結果）<br />
          &emsp; 半角文字0.5文字 / 全角文字1文字<br />
          ※総カウント数が小数点の場合は切り上げ計算となります。（例：20.5文字の場合21文字として判定）
        </p>
      </div>
    </li>
    <li v-if="detail.description" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <p>{{ detail.description }}</p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <ol class="c-list--decimal">
          <li>
            対象となるメタディスクリプションタグの内容を上記にて確認する。
          </li>
          <li>
            HPのソース（HTML）のhead内にある&lt;meta name="description"
            content="~"/&gt;に記載されている該当メタディスクリプションを確認し、修正を行う。<br />
            ※メタディスクリプションタグは120文字以内に収めてください。
          </li>
        </ol>
      </div>
    </li>
  </ul>
</template>

<script>
import { SUPPORT_DESK_SITEURL } from '@/constants';

export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ceiledDescriptionLength() {
      return Math.ceil(this.detail.descriptionLength);
    },
    blogLink() {
      return SUPPORT_DESK_SITEURL + '/articles/4402779110415';
    }
  }
};
</script>
